module.exports = __webpack_public_path__ + "static/img/ilustra_frente_cin.e3af224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dicas-doc/ilustra_frente_cin.png
// module id = Zs+l
// module chunks = 1